import { useState } from "react";
import { Input } from 'reactstrap';
import { formatCurrency } from '../../../functions/Currency';


function DecimalInput(props) {
    let [value, updateValue] = useState(props.value);
    let className = '';

    const handleChange = element => {
        const inputValue = element.target.value;
        const formattedValue = formatCurrency(inputValue);
        element.target.value = formattedValue;
        updateValue(formattedValue);
        props.onChange(element);
    };

    if (props.error) {
        className = "is-invalid";
    }
    return (
        <div>
            <Input
                id={'id_' + props.name}
                onChange={handleChange}
                className={className}
                value={value}
                type={props.type}
                name={props.name}
                readOnly={props.readOnly}
                autoFocus={props.autoFocus ? true : false}
            />
            {props.error && (
                <span
                    className="error invalid-feedback"
                    style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
}
export default DecimalInput;
